import { useEffect, useState } from "react";
import Button from "../../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import APIS from "../../../constant/Endpoint";
import useGetHook from "../../../customHooks/useGetHook";
import { DeleteIcon } from "../../../Icons/DeleteIcon/DeleteIcon";
import EditIcon from "../../../Icons/EditIcon";
import SearchBox from "../../Reusable/SearchBox/SearchBox";
import AddContactGroupModal from "../AddContactGroupModal/AddContacGroupModal";
import UpdateContactGroupModal from "../AddContactGroupModal/UpdateContactGroupModal";
import DeleteConfirmationModal from "./DeleteGroup/DeleteConfirmationModal";
import { classNames } from "../../../utils/classNames";

const ContactSearchList = ({ selectedGroupId, setSelectedGroupId }) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedGroupForUpdateId, setSelectedGroupForUpdateId] =
    useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [groupToDeleteId, setGroupToDeleteId] = useState(null);
  const [searchParams] = useSearchParams();
  const groupSearch = searchParams.get("groupSearch") || "";
  const [debouncedSearch, setDebouncedSearch] = useState(groupSearch);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(groupSearch.trim());
    }, 500);
    return () => clearTimeout(handler);
  }, [groupSearch]);

  const { data, isLoading, isError, refetch } = useGetHook({
    queryKey: ["contact-groups", debouncedSearch],
    url: APIS.CONTACT_GROUP,
    params: { search: debouncedSearch },
  });

  const handleUpdate = (id) => {
    setSelectedGroupForUpdateId(id);
    setShowUpdateModal(true);
  };

  const handleDeleteGroup = async () => {
    try {
      await fetch(`${APIS.CONTACT_GROUP}/${groupToDeleteId}`, {
        method: "DELETE",
        credentials: "include",
      });
      setGroupToDeleteId(null);
      refetch();
    } catch (error) {
      console.error("Failed to delete group:", error);
    }
  };

  return (
    <div
      className={tw`
    w-[calc(100%-80%)]
    h-full
    flex flex-col
    shrink-0 sticky top-2 z-10
  `}
    >
      <div className={tw`p-2`}>
        <h1 className={tw`text-lg font-semibold`}> Contact</h1>
      </div>
      <div
        className={tw`
    w-full h-[calc(100vh-150px)] bg-white p-2 rounded-md  flex flex-col
  `}
        style={{ boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)" }}
      >
        <div className={tw`flex items-center justify-between`}>
          <div className={tw`w-full`}>
            <SearchBox />
          </div>
        </div>

        <div className={tw`mt-4 flex-1 overflow-y-auto`}>
          <table className={tw`w-full text-sm text-left`}>
            <thead>
              <tr>
                <th className={tw`py-2 px-2`}>#</th>
                <th className={tw`py-2 px-2`}>Group Name</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={2} className={tw`py-4 text-center`}>
                    Loading...
                  </td>
                </tr>
              ) : isError ? (
                <tr>
                  <td colSpan={2} className={tw`py-4 text-center text-red-600`}>
                    Error loading data
                  </td>
                </tr>
              ) : !data || data.length === 0 ? (
                <tr>
                  <td colSpan={2} className={tw`py-4 text-center`}>
                    No groups found
                  </td>
                </tr>
              ) : (
                data.map((group, index) => (
                  <tr
                    key={group.id}
                    className={classNames(
                      selectedGroupId?.id === group.id
                        ? tw`  bg-primary-active`
                        : tw``,
                      tw`hover:bg-primary-active border-t group mb-1 relative cursor-pointer`
                    )}
                    onClick={() =>
                      setSelectedGroupId({
                        is_default: group?.is_default,
                        id: group?.id,
                      })
                    }
                  >
                    <td className={tw`py-2 px-2`}>{index + 1}</td>
                    <td className={tw`py-2 px-2 pr-4 relative`}>
                      <span>{group.name}</span>
                      <div
                        className={tw`hidden group-hover:flex gap-2 absolute right-0 top-1/2 -translate-y-1/2`}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Button
                          label={
                            <span className={tw`text-white text-xl`}>
                              <EditIcon />
                            </span>
                          }
                          size="sm"
                          onClick={() => handleUpdate(group.id)}
                          className={tw`w-6 focus:outline-none`}
                        />

                        <Button
                          label={
                            <span className={tw`text-white text-xl`}>
                              <DeleteIcon />
                            </span>
                          }
                          size="sm"
                          onClick={() => {
                            setGroupToDeleteId(group.id);
                            setShowDeleteModal(true);
                          }}
                          className={tw`w-4 focus:outline-none mr-4`}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <Button label="+ Add New" onClick={() => setShowAddModal(true)} />
      </div>
      <AddContactGroupModal isOpen={showAddModal} setIsOpen={setShowAddModal} />

      {selectedGroupForUpdateId && (
        <UpdateContactGroupModal
          isOpen={showUpdateModal}
          setIsOpen={(val) => {
            setShowUpdateModal(val);
            if (!val) {
              setSelectedGroupForUpdateId(null);
              refetch();
            }
          }}
          id={selectedGroupForUpdateId}
        />
      )}

      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        setIsOpen={setShowDeleteModal}
        onConfirm={() => {
          handleDeleteGroup();
          setShowDeleteModal(false);
        }}
        groupId={groupToDeleteId}
      />
    </div>
  );
};

export default ContactSearchList;
